<template>
    <v-tabs grow :height="$vuetify.breakpoint.lgAndUp ? 80 : ''" :slider-size="$vuetify.breakpoint.lgAndUp ? 4 : '2'">
        <v-tab exact to="/education">교육소개</v-tab>
        <!-- <v-tab exact to="/education/receipt">교육접수</v-tab> -->
        <v-tab exact to="/education/law">법률지원</v-tab>
    </v-tabs>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.v-tabs{
    position: relative;
    &::before{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: var(--v-grey-lighten3);
    }
}
.v-tab {
    &--active {
        font-weight: 800;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .v-tab {
        font-size: 24px;
    }
}
@media (min-width: 1200px) {
    .v-tabs{
        &::before{
            height: 4px;
        }
    }
}
</style>
